import {ReactComponent as AndroidSvg} from './android.svg';
import {ReactComponent as AppSvg} from './app.svg';
import {ReactComponent as AngularSvg} from './angular.svg';
import {ReactComponent as AtlassianSvg} from './atlassian.svg';
import {ReactComponent as AtomSvg} from './atom.svg';
import {ReactComponent as AwsSvg} from './aws.svg';
import {ReactComponent as BabelSvg} from './babel.svg';
import {ReactComponent as BitbucketSvg} from './bitbucket.svg';
import {ReactComponent as CircleCISvg} from './circleci.svg';
import {ReactComponent as CloudSvg} from './cloud.svg';
import {ReactComponent as CssSvg} from './css.svg';
import {ReactComponent as CustomSvg} from './custom.svg';
import {ReactComponent as D3Svg} from './d3.svg';
import {ReactComponent as DjangoSvg} from './django.svg';
import {ReactComponent as DockerSvg} from './docker.svg';
import {ReactComponent as ElectronSvg} from './electron.svg';
import {ReactComponent as ExpressSvg} from './express.svg';
import {ReactComponent as FastApiSvg} from './fastapi.svg';
import {ReactComponent as FirebaseSvg} from './firebase.svg';
import {ReactComponent as FlaskSvg} from './flask.svg';
import {ReactComponent as GearSvg} from './gear.svg';
import {ReactComponent as GitSvg} from './git.svg';
import {ReactComponent as GithubSvg} from './github.svg';
import {ReactComponent as GitlabSvg} from './gitlab.svg';
import {ReactComponent as Gitlab2Svg} from './gitlab2.svg';
import {ReactComponent as GmailSvg} from './gmail.svg';
import {ReactComponent as GoogleAdkSvg} from './google_adk.svg';
import {ReactComponent as GoogleCloudSvg} from './google_cloud.svg';
import {ReactComponent as GraphqlSvg} from './graphql.svg';
import {ReactComponent as HtmlSvg} from './html.svg';
import {ReactComponent as JavaSvg} from './java.svg';
import {ReactComponent as JavascriptSvg} from './javascript.svg';
import {ReactComponent as JenkinsSvg} from './jenkins.svg';
import {ReactComponent as JestSvg} from './jest.svg';
import {ReactComponent as KubernetesSvg} from './kubernetes.svg';
import {ReactComponent as LaptopSvg} from './laptop.svg';
import {ReactComponent as LangfuseSvg} from './langfuse.svg';
import {ReactComponent as LeftArrow} from './left-arrow.svg';
import {ReactComponent as LessSvg} from './less.svg';
import {ReactComponent as LinkedIn} from './linkedin.svg';
import {ReactComponent as LightsailSvg} from './lightsail.svg';
import {ReactComponent as MongoSvg} from './mongo.svg';
import {ReactComponent as MoonSvg} from './moon.svg';
import {ReactComponent as NginxSvg} from './nginx.svg';
import {ReactComponent as NestjsSvg} from './nestjs.svg';
import {ReactComponent as NodeSvg} from './node.svg';
import {ReactComponent as MoleculeSvg} from './molecule.svg';
import {ReactComponent as MysqlSvg} from './mysql.svg';
import {ReactComponent as NpmSvg} from './npm.svg';
import {ReactComponent as PeopleSvg} from './people.svg';
import {ReactComponent as PineconeSvg} from './pinecone.svg';
import {ReactComponent as PostgresqlSvg} from './postgresql.svg';
import {ReactComponent as PythonSvg} from './python.svg';
import {ReactComponent as ReactNativeSvg} from './react_native.svg';
import {ReactComponent as ReactSpringSvg} from './react_spring.svg';
import {ReactComponent as ReactSvg} from './react.svg';
import {ReactComponent as ReduxSagaSvg} from './redux_saga.svg';
import {ReactComponent as ReduxSvg} from './redux.svg';
import {ReactComponent as RightArrowSvg} from './right-arrow.svg';
import {ReactComponent as RocketSvg} from './rocket.svg';
import {ReactComponent as ScssSvg} from './scss.svg';
import {ReactComponent as SeleniumSvg} from './selenium.svg';
import {ReactComponent as SocketSvg} from './socket-io.svg';
import {ReactComponent as StackoverflowSvg} from './stackoverflow.svg';
import {ReactComponent as StrandsSvg} from './strands.svg';
import {ReactComponent as TwitterSvg} from './twitter.svg';
import {ReactComponent as TypescriptSvg} from './typescript.svg';
import {ReactComponent as VueSvg} from './vue.svg';
import {ReactComponent as WebpackSvg} from './webpack.svg';
import {ReactComponent as WebsocketSvg} from './websocket.svg';

export {
  AndroidSvg,
  AppSvg,
  AngularSvg,
  AtlassianSvg,
  AtomSvg,
  AwsSvg,
  BabelSvg,
  BitbucketSvg,
  CircleCISvg,
  CloudSvg,
  CssSvg,
  CustomSvg,
  D3Svg,
  DjangoSvg,
  DockerSvg,
  ElectronSvg,
  ExpressSvg,
  FastApiSvg,
  FirebaseSvg,
  FlaskSvg,
  GearSvg,
  GitSvg,
  GithubSvg,
  GitlabSvg,
  Gitlab2Svg,
  GmailSvg,
  GoogleAdkSvg,
  GoogleCloudSvg,
  GraphqlSvg,
  HtmlSvg,
  JavaSvg,
  JavascriptSvg,
  JenkinsSvg,
  JestSvg,
  KubernetesSvg,
  LaptopSvg,
  LangfuseSvg,
  LeftArrow,
  LessSvg,
  LinkedIn,
  LightsailSvg,
  MongoSvg,
  MoonSvg,
  NginxSvg,
  NestjsSvg,
  NodeSvg,
  MoleculeSvg,
  MysqlSvg,
  NpmSvg,
  PeopleSvg,
  PineconeSvg,
  PostgresqlSvg,
  PythonSvg,
  ReactNativeSvg,
  ReactSpringSvg,
  ReactSvg,
  ReduxSagaSvg,
  ReduxSvg,
  RightArrowSvg,
  RocketSvg,
  ScssSvg,
  SeleniumSvg,
  SocketSvg,
  StackoverflowSvg,
  StrandsSvg,
  TwitterSvg,
  TypescriptSvg,
  VueSvg,
  WebpackSvg,
  WebsocketSvg
};
